const Data = [
    {
        name: "Ajay Paliwal",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Heads23/AjayPaliwal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100075660422516&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/ajay-paliwal-b7a9b8223?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "ajay.paliwal@gyws.org"
    },
    {
        name: "Shivam Yadav",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Heads23/ShivamYadav.jpg",
        facebookLink: "https://www.facebook.com/Shivam.satmanju",
        linkedinLink: "https://www.linkedin.com/in/shivamyadav1710/",
        email: "shivam.yadav@gyws.org"
    },
    {
        name: "Virat Dwivedi",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Heads23/ViratDwivedi.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100006798225731",
        linkedinLink: "https://www.linkedin.com/in/virat-dwivedi-55912a202/",
        email: "virat.dwivedi@gyws.org"
    },
]

export default Data;